module.exports = __webpack_public_path__ + "static/boardbooks-536991903c27c17d799e378e631f8abd.png";